<template>
  <div class="w_inner">
    <div class="innerWrap">
      <div class="breadmapShow">
        <div class="bread-wrapper w">
          <span><router-link :to="{ name: 'home' }">{{ $t('product.nav') }}</router-link></span>
          <span>{{ dto.title }}</span>
        </div>
      </div>
      <div class="main_container">
        <template v-for="(item, index) in procontent">
          <div :class="'about_desc ' + (index % 2 == 0 ? 'color_white' : 'color_blue')"
            :style="index == 0 ? 'margin-top: 70px;' : ''">
            <div class="atitle wow fadeInUp animated">
              {{ item.title }}
            </div>
            <div class="desc_box w clearfix">
              <div :class="'imgShow wow animated ' + (index % 2 == 0 ? 'right fadeInRight' : 'left fadeInLeft')"
                data-wow-delay="0.2s">
                <img :src="item.img" alt="">
              </div>
              <div class="testShow">
                <div class="descCon wow fadeInUp animated" data-wow-delay="0.2s">
                  <p style="color: #333;font-weight: bold;font-size: 34px;padding-bottom:12px">
                    {{ item.subTitle }}
                  </p>
                  <p v-html="utils.ShowContentBr(item.content)">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="proDetailDesc color_white" style="display: none;">
          <div class="DescBox w">
            <div class="contentList">
              <ul>
                <template v-for="(item, index) in procontent">
                  <li :key="index" class="wow fadeInUp animated" data-wow-delay="0.1s">
                    <div class="bgImg">
                      <img :src="item.img">
                    </div>
                    <div class="text_con">
                      <div class="box">
                        <div class="tibar">{{ item.title }}</div>
                        <div class="subTitle" v-if="item.subTitle">{{ item.subTitle }}</div>
                        <div class="con" v-html="utils.ShowContentBr(item.content)">
                        </div>
                      </div>
                    </div>
                  </li>
                </template>

              </ul>
            </div>
          </div>
        </div>
        <div class="proLingyuDesc color_grey" style="display: none;">
          <div class="DescBox w">
            <div class="title wow fadeInUp animated" data-wow-delay="0.3s">{{ $t('product.area') }}</div>
            <div class="lingyuList clearfix">
              <ul v-if="CategoryList && dto.categoryIds">
                <template v-for="item in CategoryList" v-if="dto.categoryIds.indexOf(',' + item.id + ',') > -1">
                  <li :key="item.id">
                    <router-link :to="{ name: 'product', params: { id: item.id } }">
                      <div class="imgShow">
                        <img :src="item.imgUrl">
                      </div>
                      <div v-if="currentLang == 'zh'" class="nameShow">{{ item.title }}</div>
                      <div v-else class="nameShow">{{ item.enTitle }}</div>
                    </router-link>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import WOW from "../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      id: this.$route.params.id,
      dto: {},
      procontent: [],
      currentLang: this.$i18n.locale
    }
  },
  computed: {
    ...mapState({
      CategoryList: state => state.CategoryList
    })
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    document.documentElement.scrollTop = 0;
  },
  created: function () {
    this.GetProInfo();
  },
  methods: {
    GetProInfo() {
      var url = "/pageapi/Product/GetDetail";
      this.$http.post(url, { id: this.$route.params.id }).then(function (res) {
        if (res.data.status == 1) {
          this.procontent = JSON.parse(res.data.ds.content);
          this.dto = res.data.ds;
          this.$nextTick(function () {
            this.Initwow();
          });
          // console.log(this.procontent);
        }
      }.bind(this)).catch(function () {
      });
    },
    Initwow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  },
};
</script>
